export default {
  text: 'We zetten je tafel klaar 🍽…',
};
